export interface PodcastEpisode {
  uid: string
  episodeId: string
  showId: string
  name: string
  description?: string
  htmlDescription?: string
  releaseDate?: Date
  releaseDateRaw?: string
  releaseDatePrecision?: string
  durationMs?: number
  explicit?: boolean
  isPlayable?: boolean
  isExternallyHosted?: boolean
  languages: string[]
  imageUrl?: string
  spotifyUrl?: string
  spotifyUri?: string
  audioPreviewUrl?: string
  embedUrl?: string
  vimeoVideoId?: string
  vimeoPlayerUrl?: string
  vimeoEmbedUrl?: string
  vimeoSourcePageUrl?: string
  vimeoSourceEpisodeTitle?: string
  vimeoSourcePublishedAt?: Date
  vimeoMatchConfidence?: number
  vimeoMatchReason?: string
  vimeoMatchedAt?: Date
  vimeoLastSeenAt?: Date
  isActive: boolean
  syncedAt?: Date
  updatedAt?: Date
  createdAt?: Date
}

function hasContent(value: string | undefined): value is string {
  return typeof value === 'string' && value.trim().length > 0
}

export function selectPreferredPodcastEmbedUrl(
  episode: Pick<PodcastEpisode, 'vimeoEmbedUrl' | 'vimeoPlayerUrl' | 'embedUrl'>,
): string | undefined {
  if (hasContent(episode.vimeoEmbedUrl)) {
    return episode.vimeoEmbedUrl
  }

  if (hasContent(episode.vimeoPlayerUrl)) {
    return episode.vimeoPlayerUrl
  }

  if (hasContent(episode.embedUrl)) {
    return episode.embedUrl
  }

  return undefined
}

export function hasPreferredVimeoEmbedUrl(
  episode: Pick<PodcastEpisode, 'vimeoEmbedUrl' | 'vimeoPlayerUrl'>,
): boolean {
  return hasContent(episode.vimeoEmbedUrl) || hasContent(episode.vimeoPlayerUrl)
}

export function buildSpotifyEpisodeEmbedUrl(episodeId: string | undefined): string | undefined {
  if (!hasContent(episodeId)) {
    return undefined
  }

  return `https://open.spotify.com/embed/episode/${episodeId}`
}
